interface CookieArgs {
  name: string;
  value: string;
  days?: number;
}

const setCookie = ({ name, value, days }: CookieArgs) => {
  let expires = '';
  let date;
  if (days) {
    date = new Date();
    // multiply the number of days to get milliseconds
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
  } else {
    // if we aren't setting the number of days,
    // we're actually removing the cookie, so
    // we set the date = the unix epoch
    date = new Date(0);
  }
  expires = 'expires=' + date.toUTCString();

  document.cookie = `${name}=${value};${expires};domain=.odynn.com;path=/`;
  // document.cookie = `${name}=${value};${expires};domain=localhost;path=/`;
};

const getCookie = (name: string): string | null => {
  const nameLengthPlus = name.length + 1;
  const { cookie } = document;
  return (
    cookie
      .split(';')
      .map((c) => c.trim())
      .filter((cookieElem) => {
        return cookieElem.substring(0, nameLengthPlus) === `${name}=`;
      })
      .map((cookieElem) => {
        return decodeURIComponent(cookieElem.substring(nameLengthPlus));
      })[0] ?? null
  );
};

export { setCookie, getCookie };
